import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import actions from '../../../redux/actions/index';
import * as enums from '../../../utils/enums';
import toastr from 'toastr';
import _reject from 'lodash/reject';
import _isEmpty from 'lodash/isEmpty';
import InventoryUtils from '../../../utils/inventory-utils';
import FreesaleComponent from './freesale';

class FreesaleComponentContainer extends Component {
    constructor(props) {
        super(props);
        this.onConfigurationOptionChange = this.onConfigurationOptionChange.bind(this);
        this.onFreesaleStatusChange = this.onFreesaleStatusChange.bind(this);
        this.onRoomTypeMaxAllotmentChange = this.onRoomTypeMaxAllotmentChange.bind(this);
        this.onCheckboxChange = this.onCheckboxChange.bind(this);
    }

    onCheckboxChange(property, e) {
        const value = e.target.checked;

        let inventoryObject = {
            ...this.props.model,
            freesaleActive: value,
            allocationActive: true
        };

        this.props.actions.setModelObject(inventoryObject);
    }

    onFreesaleStatusChange(freesaleStatus) {
        const { freesale } = this.props.model;
        let newVal = freesaleStatus.find((x) => x.selected).id;
        let status = newVal === freesale.status ? enums.FIXED : newVal;
        const freesaleData = {
            ...freesale,
            status: status,
            count: status === enums.OPEN ? '∞' : status === enums.CLOSED ? 'C' : 10,
            releaseDays: status === enums.CLOSED ? 'C' : 0
        };

        const roomsValue = this.changeDefaultMaxRooms(status);

        let modelObj = { ...this.props.model, freesale: freesaleData, freesaleRooms: roomsValue };

        this.props.actions.setModelObject(modelObj);
    }

    changeDefaultMaxRooms(status) {
        return this.props.model.freesaleRooms.map((x) => {
            return {
                name: x.name,
                nameLower: x.name.toLowerCase(),
                id: x.id,
                allotment: status == enums.OPEN ? enums.DEFAULT_ROOM_FREESALE_OPEN : enums.DEFAULT_ROOM_ALLOCATION,
                availableAllotment:
                    status == enums.OPEN ? enums.DEFAULT_ROOM_FREESALE_OPEN : enums.DEFAULT_ROOM_ALLOCATION
            };
        });
    }

    checkClosedAllocationFreesaleCount() {
        let freeSaleCount =
            this.props.model.freesale.count === 'C'
                ? enums.CLOSED_ALLOCATION_FREESALE
                : this.props.model.freesale.count === '∞' ? enums.OPEN_INFINITY : this.props.model.freesale.count;

        return freeSaleCount;
    }

    onConfigurationOptionChange(property, value) {
        let count = this.props.model.freesaleRooms.reduce((prev, current) => prev + Number(current.allotment), 0);
        let changedFreesale = { ...this.props.model.freesale, [property]: value };

        // Checks if allocation is less that the total number of rooms (avoid if prop[1] = 'releaseDays')
        if (property === 'count' && count <= value) {
            toastr.warning('Total Freesale must be less than total quantity of rooms.');
            changedFreesale.count = count < 0 ? 0 : count;
        }

        const changeObj = { ...this.props.model, freesale: changedFreesale };
        this.props.actions.setModelObject(changeObj);
    }

    onRoomTypeMaxAllotmentChange(isEdit, room, value) {
        const { freesaleRooms, inventory } = this.props.model;
        let newAllotment = Object.assign({}, room, { allotment: value, availableAllotment: value });
        let roomTypes = [];

        if (isEdit) {
            roomTypes = freesaleRooms.length === 0 ? this.getRoomTypesForCategory(inventory) : freesaleRooms;

            roomTypes = _reject(roomTypes, function(o) {
                return o.name === room.name;
            });
        } else {
            roomTypes = _reject(freesaleRooms, function(o) {
                return o.name === room.name;
            });
        }

        roomTypes.push(newAllotment);

        roomTypes = InventoryUtils.getRoomTypesSorted(
            roomTypes,
            inventory.hotel.roomCategories.find((r) => r.name === inventory.roomCategoryName).roomTypes
        );

        const dataToSave = { ...this.props.model, freesaleRooms: roomTypes };

        this.props.actions.setModelObject(dataToSave);
    }

    getRoomTypesForCategory(inventory) {
        let roomTypes = inventory.hotel.roomCategories.find((y) => y.name == inventory.roomCategoryName).roomTypes;

        roomTypes = InventoryUtils.getRoomTypesSorted(roomTypes, roomTypes);

        roomTypes.map((x) => {
            x.allotment = this.props.model.allocationRooms[x.name];
        });

        return roomTypes;
    }

    render() {
        return (
            <FreesaleComponent
                model={this.props.model}
                onCheckboxChange={this.onCheckboxChange}
                onConfigurationOptionChange={this.onConfigurationOptionChange}
                onFreesaleStatusChange={this.onFreesaleStatusChange}
                onRoomTypeMaxAllotmentChange={this.onRoomTypeMaxAllotmentChange}
            />
        );
    }
}

function mapStateToProps(state) {
    let model = {
        ...state.model,
        readOnly: false,
        editIndex: state.model.editIndex === 'undefined' ? -1 : state.model.editIndex
    };

    return {
        token: state.oidc.user !== null ? state.oidc.user.id_token : '',
        settings: state.settings,
        model
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(actions, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(FreesaleComponentContainer);
